import { render, staticRenderFns } from "./userConfiguration.vue?vue&type=template&id=27f7a230&"
import script from "./userConfiguration.js?vue&type=script&lang=js&"
export * from "./userConfiguration.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports